
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FAB4CD","d":"M4.576 39.909l120.146 3.811-2.31-31.015L1 10.405z"}}),_c('path',{attrs:{"stroke":"#000","d":"M86.467 5.595l-.234 18.116M40.873 5.004l-.234 18.116M6.044 54.096h114.712M5.872 68.367H120.45M5.872 82.639H120.45M5.55 96.911h114.603"}}),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M87.48 54.096v56.407M104.344 54.096v56.407M70.617 54.096v56.407M53.754 54.096v56.407M36.891 54.096v56.748M20.027 54.096v56.748M45.549 110.843h74.466l1.124-95.429L6.432 13.825l-.882 97.018h16.325z"}})]),_c('path',{attrs:{"fill":"#FFD250","d":"M126.935 93.051c0 16.293-13.208 29.5-29.501 29.5s-29.5-13.207-29.5-29.5c0-16.292 13.207-29.5 29.5-29.5s29.5 13.208 29.5 29.5"}}),_c('path',{attrs:{"stroke":"#231F20","stroke-width":".8","d":"M118.895 96.834c0 11.458-9.291 20.746-20.747 20.746-11.457 0-20.748-9.288-20.748-20.746 0-11.458 9.29-20.745 20.748-20.745 11.456 0 20.747 9.287 20.747 20.745z"}}),_c('path',{attrs:{"stroke":"#000","d":"M97.557 86.466v10.37l10.662 8.576M87.457 114.617l-4.236 7.651M86.918 79.017l-1.873-2.605M90.256 73.57a5.762 5.762 0 00-9.958 5.447l9.958-5.446zM108.837 114.617l4.01 7.651M109.15 79.017l1.873-2.605M105.812 73.57a5.762 5.762 0 019.958 5.447l-9.958-5.446z"}})])])
          )
        }
      }
    